const ElementLabel = ({string, close}) => {
    return (
        <div className="border-2 border-[#225424] text-black py-2 px-3 rounded-lg flex items-center justify-between gap-2 text-lg w-full">{string} <div className="pt-2"><i className="fi fi-sr-circle-xmark text-xl cursor-pointer" onClick={() => {close(string)}}></i></div></div>
    )
}

export default ElementLabel;